import React, { useState, useEffect } from "react";
import Helmet from 'react-helmet';
import { connect } from 'react-redux';
import { BASIC_SETTING } from 'helpers/viewContent';
import {  Link } from 'react-router-dom';

//imported
import { FORMAT_TEXT_VALUE } from "helpers/common";
import * as Path from 'routes/paths';
import * as actions from 'store/actions/index.js';
import { getWithoutPaginationList_, updateData_ } from "store/services/commonService";

const Listing = ({ dispatch }) => {
    const [listing, setListing] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isShow, setIsShow] = useState(false);
    const [permissions, setPermissions] = useState([]);

    const fetchData = async () => {
        try {
            let query = {
                url: "basic_setting/list",
            };
            setIsLoading(true);
            dispatch(actions.persist_store({ loader: true }));
            let res = await dispatch(getWithoutPaginationList_(query));
            dispatch(actions.persist_store({ loader: false }));
            setListing(res?.body);
            setPermissions(res?.body);
            setIsLoading(false);
        } catch (err) {
            setIsLoading(false);
            dispatch(actions.persist_store({ loader: false }));
            console.log(err);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);
    
    const updatePermissionField = async (e, id) => {
        const { checked } = e.target;
        const updatedPermissions = permissions.map(permission => {
            if (permission.id === id) {
                return { ...permission, status: checked ? '1' : '0' };
            }
            return permission;
        });
        setPermissions(updatedPermissions);
    };

    const handleSubmit = async () => {
        try{
            let newArray = []
            for(let val of permissions){
                let obj = {
                    id:val.id,
                    status:val.status
                }
                newArray.push(obj)
            }
            let query = {
                fields : JSON.stringify(newArray),
                url :"basic_setting/update_status",
            } 
            setIsShow(true)
            dispatch(actions.persist_store({ loader: true }));
            await dispatch(updateData_(query));
            setIsShow(false)
            dispatch(actions.persist_store({ loader: false }));
            fetchData();
        } catch (err) {
            setIsShow(false)
            dispatch(actions.persist_store({ loader: false }));
            console.log(err);
        }
    };
    return(
        <>
            <Helmet title={BASIC_SETTING.CURRENT_MODULE} />
            <div className="page-header">
                <h3 className="page-title">
                    <span className="page-title-icon bg-gradient-primary text-white me-2">
                    <i className="mdi mdi-format-list-bulleted menu-icon"></i>
                    </span>  {BASIC_SETTING.CURRENT_MODULE}
                </h3>
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                    <li className="breadcrumb-item"><Link to={Path.basic_setting}>{BASIC_SETTING.CURRENT_MODULE}</Link></li>
                    </ol>
                </nav>
            </div>
            <div className="row">
                <div className="col-12 grid-margin stretch-card">
                    <div className="card">
                        <div className="card-body">
                            <h4 className="card-title">User personal detail</h4>
                                <div className="form-group">
                                    <div className="row">
                                            {listing?.length > 0 && listing?.map((list, i) => {
                                                if(list?.module==="users"){
                                                return(
                                                    <>
                                                    <div className="col-md-3" key={i}>
                                                        <label className=""></label>
                                                        <div className="form-group">
                                                            <label className="">
                                                            <input type="checkbox" className="pointer-cursor" 
                                                            name="status" onChange={(e) => updatePermissionField(e, list?.id)} 
                                                            checked={permissions.find(permission => permission.id === list?.id)?.status === '1'} 
                                                            /> {FORMAT_TEXT_VALUE(list.field)} 
                                                            </label>
                                                        </div>
                                                    </div>  
                                                    </>
                                                )
                                                }
                                            })}
                                    </div>
                                </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-12 grid-margin stretch-card">
                    <div className="card">
                        <div className="card-body">
                            <h4 className="card-title">User match preferences detail</h4>
                                <div className="form-group">
                                    <div className="row">
                                            {listing?.length > 0 && listing?.map((list, i) => {
                                                if(list?.module==="user_preferences"){
                                                return(
                                                    <>
                                                    <div className="col-md-3" key={i}>
                                                        <label className=""></label>
                                                        <div className="form-group">
                                                            <label className="">
                                                            <input type="checkbox" className="pointer-cursor"  name="status" onChange={(e) => updatePermissionField(e, list?.id)}
                                                              checked={permissions.find(permission => permission.id === list?.id)?.status === '1'} 
                                                            /> {FORMAT_TEXT_VALUE(list.field)} 
                                                            </label>
                                                        </div>
                                                    </div>  
                                                    </>
                                                )
                                                }
                                            })}
                                    </div>
                                </div>
     
                        </div>
                    </div>
                </div>
            </div>
            <button type="submit" disabled={isShow ? true : false} onClick={handleSubmit} className="btn btn-gradient-primary me-2 float-right">{isShow ? 'Wait..' : 'Update'}</button>
         
        </>

    )
}
const mapStateToPros = (state) => {
    return{
    }
  };
  function mapDispatchToProps(dispatch) {
    return { dispatch };
  }
  
  export default connect(
  mapStateToPros,
  mapDispatchToProps
  )(Listing);